import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Danger = ({
  size,
  type,
  theme,
  className,
  dataTestId = "danger-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M5.53 5.529c.26-.26.682-.26.942 0l1.529 1.528L9.529 5.53a.667.667 0 0 1 .943.943L8.944 8l1.528 1.529a.667.667 0 0 1-.943.943l-1.528-1.53-1.529 1.53a.667.667 0 0 1-.943-.943L7.058 8 5.529 6.471a.667.667 0 0 1 0-.942Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.368.842a2 2 0 0 1 1.265 0L13.3 2.397a2 2 0 0 1 1.367 1.898v5.039c0 2.066-1.353 3.476-2.711 4.368-1.366.897-2.873 1.366-3.495 1.536a1.74 1.74 0 0 1-.92 0c-.622-.17-2.13-.64-3.496-1.536-1.358-.892-2.711-2.302-2.711-4.368v-5.04a2 2 0 0 1 1.368-1.897L7.368.842Zm.843 1.265a.667.667 0 0 0-.421 0L3.123 3.662a.667.667 0 0 0-.456.633v5.039c0 1.406.909 2.464 2.11 3.253 1.194.784 2.544 1.209 3.114 1.364.074.02.146.02.22 0 .57-.155 1.92-.58 3.113-1.364 1.202-.789 2.11-1.847 2.11-3.253v-5.04a.667.667 0 0 0-.456-.632L8.211 2.107Z"
    />
  </SVGIcon>
);
